import type { FontUsage, TextOverlay } from "./types";

export const isScannedPage = (characterCount: number, itemCount: number) =>
  characterCount < 12 || itemCount < 2;

export const aggregateFonts = (items: TextOverlay[]): FontUsage[] => {
  const usage = new Map<string, FontUsage>();
  for (const item of items) {
    if (!item.text.trim()) continue;
    const key = `${item.fontName}|${item.fontFamily}`;
    const current = usage.get(key) ?? {
      id: key,
      internalName: item.fontName,
      family: item.fontFamily || "Unknown font",
      source: "native",
      count: 0,
      characters: 0,
      minSize: Number.POSITIVE_INFINITY,
      maxSize: 0,
      pages: [],
    };
    current.count += 1;
    current.characters += item.text.length;
    current.minSize = Math.min(current.minSize, item.fontSize);
    current.maxSize = Math.max(current.maxSize, item.fontSize);
    if (!current.pages.includes(item.pageIndex + 1)) current.pages.push(item.pageIndex + 1);
    usage.set(key, current);
  }
  return [...usage.values()].sort((a, b) => b.characters - a.characters);
};

export const aggregateOcrFonts = (items: TextOverlay[]): FontUsage[] => {
  const usage = new Map<string, FontUsage & { confidenceTotal: number }>();
  for (const item of items) {
    if (item.source !== "ocr" || !item.text.trim()) continue;
    const weight = item.fontWeight || 400;
    const style = item.fontStyle || "normal";
    const key = `ocr|${item.fontFamily}|${weight}|${style}`;
    const current = usage.get(key) ?? {
      id: key,
      internalName: "OCR odhad z obrazu",
      family: item.fontFamily || "Unknown font",
      source: "ocr",
      fontWeight: weight,
      fontStyle: style,
      confidence: 0,
      confidenceTotal: 0,
      count: 0,
      characters: 0,
      minSize: Number.POSITIVE_INFINITY,
      maxSize: 0,
      pages: [],
    };
    current.count += 1;
    current.characters += item.text.length;
    current.minSize = Math.min(current.minSize, item.fontSize);
    current.maxSize = Math.max(current.maxSize, item.fontSize);
    current.confidenceTotal += item.fontMatchConfidence ?? 0.5;
    current.confidence = current.confidenceTotal / current.count;
    if (!current.pages.includes(item.pageIndex + 1)) current.pages.push(item.pageIndex + 1);
    usage.set(key, current);
  }
  return [...usage.values()]
    .map(({ confidenceTotal: _confidenceTotal, ...font }) => font)
    .sort((a, b) => b.characters - a.characters);
};
